export default __webpack_public_path__ + "static/media/180.54e98ae9.png";